export const ACTIVE_TAB_CLASSES = Object.freeze([
  'active',
  'gl-tab-nav-item-active',
  'gl-tab-nav-item-active-indigo',
]);

export const ACTIVE_PANEL_CLASS = 'active';

export const KEY_CODE_LEFT = 'ArrowLeft';
export const KEY_CODE_UP = 'ArrowUp';
export const KEY_CODE_RIGHT = 'ArrowRight';
export const KEY_CODE_DOWN = 'ArrowDown';

export const ATTR_ARIA_CONTROLS = 'aria-controls';
export const ATTR_ARIA_LABELLEDBY = 'aria-labelledby';
export const ATTR_ARIA_SELECTED = 'aria-selected';
export const ATTR_ROLE = 'role';
export const ATTR_TABINDEX = 'tabindex';

export const TAB_SHOWN_EVENT = 'gl-tab-shown';
